import { PaymentKind } from '@/constants/common'
import type { PaymentResult } from '@/types/common'
import { type PaymentMethodValues } from '@/components/form'

export function groupPaymentMethods(data: Record<string, any>) {
  return data.getUserPaymentMethods.reduce(
    (acc: PaymentResult, method: any) => {
      if (method.kind === PaymentKind.bank) {
        acc.bank.push(method)
      } else if (method.kind === PaymentKind.alipay) {
        acc.alipay.push(method)
      } else if (method.kind === PaymentKind.wechat) {
        acc.wechat.push(method)
      } else if (method.kind === PaymentKind.ermb) {
        acc.ermb.push(method)
      } else if (method.kind === PaymentKind.qq) {
        acc.qq.push(method)
      }
      return acc
    },
    {
      bank: [],
      alipay: [],
      wechat: [],
      ermb: [],
      qq: []
    }
  )
}

export function getPaymentMethod(paymentInfo: Record<string, any>) {
  if (paymentInfo.bank !== null) {
    return 'bank'
  } else if (paymentInfo.alipay !== null) {
    return 'alipay'
  } else if (paymentInfo.wechat !== null) {
    return 'wechat'
  } else if (paymentInfo.ermb !== null) {
    return 'ermb'
  } else if (paymentInfo.qq !== null) {
    return 'qq'
  } else {
    return ''
  }
}

export function getUploadPaymentInput({ name, bankName, branchName, account, url }: PaymentMethodValues, kind: string) {
  switch (kind) {
    case 'bank': {
      return {
        bankInfo: {
          name,
          bankName,
          branchName,
          account
        }
      }
    }
    case 'alipay': {
      return {
        alipay: {
          name,
          account,
          qrCode: url
        }
      }
    }
    case 'wechat': {
      return {
        wechat: {
          name,
          account,
          qrCode: url
        }
      }
    }
    case 'ermb': {
      return {
        ermb: {
          name,
          account
        }
      }
    }
    case 'qq': {
      return {
        qq: {
          name,
          account,
          qrCode: url
        }
      }
    }
  }
}

export function groupPaymentMethodsKeys(data: Record<string, any>) {
  const initialData = {
    bank: [],
    alipay: [],
    wechat: [],
    ermb: [],
    qq: []
  }
  if (!data) {
    return initialData
  }
  return data.getUserPaymentMethods.reduce((acc: PaymentResult, method: any) => {
    if (method.kind === PaymentKind.bank) {
      acc.bank.push(method.info.bank.account)
    } else if (method.kind === PaymentKind.alipay) {
      acc.alipay.push(method.info.alipay.account)
    } else if (method.kind === PaymentKind.wechat) {
      acc.wechat.push(method.info.wechat.account)
    } else if (method.kind === PaymentKind.ermb) {
      acc.ermb.push(method.info.ermb.account)
    } else if (method.kind === PaymentKind.qq) {
      acc.qq.push(method.info.qq.account)
    }
    return acc
  }, initialData)
}
